import { ProfesionalProvider } from "../context/ProfesionalContext";
import InnerLandingLayout from "./InnerLandingLayout";


const LandingLayout = ({ className }: any) => {

  return (
    <ProfesionalProvider>
      <InnerLandingLayout className={className} />
    </ProfesionalProvider>
  );
};

export default LandingLayout;